module.exports = {
  send_code_hint: 'We will send an authentication code to this number.',
  send_whatsapp: 'SEND WHATSAPP',
  do_you_have_username_password: 'Do you have username & password?',
  sigin_to_workspace: 'SIGN IN TO WORKSPACE',
  dont_have_account_pos: 'Don\'t have an account in TokoPOS?',
  download_pos_from: 'Download TokoPOS from',
  send_auth_code_via: 'We are going to send an authentication code to the number',
  check_auth_code: 'Please help to make sure you enter the correct mobile number.',
  re_enter: 'Re-Enter',
  continue: 'Continue',
  auth_code: 'Authentication Code',
  auth_code_sent: 'An authentication code is sent to',
  check_auth_code_and_fill: 'Please check and fill in',
  enter_auth_code: 'Enter Authentication Code',
  verify: 'VERIFY',
  send_auth_after: 'Send authentication code again after',
  resend_new_code: 'RESEND NEW CODE',
  workspace: 'Workspace',
  password: 'Password',
  workspace_login_incorrect: 'Workspace, username, or password is incorrect.',
  please_enter_username: 'Please enter username',
  please_enter_mobile_phone: 'Please enter mobile number',
  please_enter_workspace: 'Please enter workspace',
  back_to_login_form: 'Back to Login Form',
  sign_in_with_phone_number: 'SIGN IN WITH MOBILE NUMBER',
  confirm_mobile_number: 'Confirm Mobile Number',
}
